export default __webpack_public_path__ + "assets/img_present_agreement_xl-8d317b90.png";